import React, { useContext } from "react";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import styled from "styled-components";

import GlobalContext from "../Hooks/globalContext";
import Main from "../Pages/Main";
import Config from "../Pages/Config";
import Language from "../Pages/Config/Language";
import Exchange from "../Pages/Config/Exchange";
import Send from "../Pages/Send";
import History from "../Pages/History";
import Staking from "../Pages/Staking";
import Swap from "../Pages/Swap";
import NoticeDetail from "../Pages/Notice/Detail";
import Notice from "../Pages/Notice";

import Header from "./Common/Header";
import Footer from "./Common/Footer";

import Admin from "../Pages/Admin";
import Auth from "../Pages/Auth";
import Privacy from "../Pages/Privacy";
import Terms from "../Pages/Terms";

const LoginRoutes = ({ user }) => {
  const history = useHistory();
  return (
    <Switch>
      {/* <Route exact path="/" component={Main} />
      <Route exact path="/more" component={Config} />
      <Route exact path="/language" component={Language} />
      <Route exact path="/exchange" component={Exchange} />
      <Route exact path="/send" component={Send} />
      <Route exact path="/send/:asset" component={Send} />
      <Route exact path="/history" component={History} /> */}
      {/* <Route exact path="/staking" component={Staking} /> */}
      {/* <Route exact path="/notice/:noticeId" component={NoticeDetail} /> */}
      {/* <Route exact path="/notice" component={Notice} /> */}
      {/* <Route exact path="/swap" component={Swap} /> */}
      <Route exact path="/" component={Admin} />

      <Redirect from="*" to="/" />
    </Switch>
  );
};

const LogoutRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" render={(props) => <Auth {...props} page="login" />} />
      <Redirect from="*" to="/" />
    </Switch>
  );
};

const AppRouter = () => {
  const { isLogin, user } = useContext(GlobalContext);
  return (
    <Switch>
      <Route exact path="/privacy" component={Privacy} />
      <Route exact path="/terms" component={Terms} />
      <Route path="*" render={() => (isLogin.state ? <LoginRoutes user={user} /> : <LogoutRoutes />)} />
    </Switch>
  );
};

export default AppRouter;
